import Light from 'elem/SVGIcon/PowerBackup/Light';
import Phone from 'elem/SVGIcon/PowerBackup/Phone';
import CoffeeMaker from 'elem/SVGIcon/PowerBackup/CoffeeMaker';
import Refrigerator from 'elem/SVGIcon/PowerBackup/Refrigerator';
import ElectricOven from '@/components/UI/svg/solar-calculator/ElectricOven';
import Microwave from 'elem/SVGIcon/PowerBackup/Microwave';
import AirConditioner from 'elem/SVGIcon/PowerBackup/AirConditioner';
import WaterPump from 'elem/SVGIcon/VanlifeRoadtrips/WaterPump';
import EFElectricHeater from '@/components/UI/svg/LandingPage/EFElectricHeater';
import { useGlobal } from '@/utils/useGlobal';
import Dryer from '@elem/SVGIcon/Homebattery/Dryer';
import Washer from 'elem/SVGIcon/PowerBackup/Washer';

const IMG_MAP: any = {
    ca: [
        '/responsive/picture/common-products/delta2max.png',
        '/responsive/picture/common-products/deltapro.png',
        '/responsive/picture/common-products/deltapro_smarthomepanel.png',
    ],
};
export default function (locale = 'ca') {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('powerbackup');

    const caCardList = [
        {
            img: '',
            tag: t('common_card_tag_new_arrival'),
            power: t('secG_card4_power'),
            title: t('secG_card4_title'),
            link_more: (() => {
                const localMap: any = {
                    us: '/delta-pro-ultra',
                    ca: 'https://ca.ecoflow.com/products/delta-pro-ultra?variant=44244774650010',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '6964802453577',
                    ca: '8006700236954',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '40758830071881',
                    ca: '44244774650010',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [
                t('secG_card4_desc1'),
                t('secG_card4_desc2'),
                t.rich('secG_card4_desc3', {
                    ts: (text: string) => (
                        <Link className="ts" href={t('secG_card4_desc3_link')}>
                            {text}
                        </Link>
                    ),
                }),
            ],
            iconArr: [
                {
                    icon: <Refrigerator className="card-icon" />,
                    title: t.rich('secG_card4_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card4_icon1_desc'),
                },
                {
                    icon: <Washer className="card-icon" />,
                    title: t.rich('secG_card4_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card4_icon2_desc'),
                },
                {
                    icon: <Microwave className="card-icon" />,
                    title: t.rich('secG_card4_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card4_icon3_desc'),
                },
                {
                    icon: <AirConditioner className="card-icon" />,
                    title: t.rich('secG_card4_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card4_icon4_desc'),
                },
                {
                    icon: <Dryer className="card-icon" />,
                    title: t.rich('secG_card4_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card4_icon5_desc'),
                },
                {
                    icon: <WaterPump className="card-icon" />,
                    title: t.rich('secG_card4_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card4_icon6_desc'),
                },
            ],
        },
        {
            img: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718875722852/sl_DP3.png',
            tag: t('common_card_tag_new_arrival'),
            power: '4kWh | 4000W｜120V/240V',
            title: 'EcoFlow DELTA Pro 3',
            link_more: (() => {
                const localMap: any = {
                    ca: 'https://ca.ecoflow.com/products/delta-pro-3-portable-power-station?variant=44902384599194',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    ca: '8231332380826',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    ca: '44902384599194',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: ['2600W dual-port solar input', '10 ms UPS', 'Auto-switchover, prolonged backup, and energy bill savings with EcoFlow Smart Home Panel 2'],
            iconArr: [
                {
                    icon: <WaterPump className="card-icon" />,
                    title: t.rich('secG_card1_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card1_icon1_desc'),
                },
                {
                    icon: <AirConditioner className="card-icon" />,
                    title: t.rich('secG_card1_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card1_icon2_desc'),
                },
                {
                    icon: <ElectricOven className="card-icon oven" />,
                    title: t.rich('secG_card1_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card1_icon3_desc'),
                },
                {
                    icon: <EFElectricHeater className="card-icon g" />,
                    title: t.rich('secG_card1_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card1_icon4_desc'),
                },
                {
                    icon: <Microwave className="card-icon" />,
                    title: t.rich('secG_card1_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card1_icon5_desc'),
                },
                {
                    icon: <Refrigerator className="card-icon" />,
                    title: t.rich('secG_card1_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card1_icon6_desc'),
                },
            ],
        },
        {
            img: locale === 'au' ? '' : IMG_MAP[locale]?.[1] || IMG_MAP.us[1],
            tag: t('common_card_tag_recommended'),
            power: t('secG_card2_power'),
            title: t('secG_card2_title'),
            link_more: (() => {
                const localMap: any = {
                    ca: 'https://ca.ecoflow.com/products/delta-pro-portable-power-station',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    ca: '6944959824026',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    ca: '43725958873242',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [
                t('secG_card2_desc1'),
                t('secG_card2_desc2'),
                t.rich('secG_card2_desc3', {
                    ts: (text: string) => (
                        <Link className="ts" href={t('secG_card2_desc3_link')}>
                            {text}
                        </Link>
                    ),
                }),
            ],
            iconArr: [
                {
                    icon: <Light className="card-icon" />,
                    title: t.rich('secG_card2_icon1_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card2_icon1_desc'),
                },
                {
                    icon: <Phone className="card-icon" />,
                    title: t.rich('secG_card2_icon2_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card2_icon2_desc'),
                },
                {
                    icon: <Refrigerator className="card-icon" />,
                    title: t.rich('secG_card2_icon3_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card2_icon3_desc'),
                },
                {
                    icon: <CoffeeMaker className="card-icon" />,
                    title: t.rich('secG_card2_icon4_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card2_icon4_desc'),
                },
                {
                    icon: <Microwave className="card-icon" />,
                    title: t.rich('secG_card2_icon5_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card2_icon5_desc'),
                },
                {
                    icon: <AirConditioner className="card-icon" />,
                    title: t.rich('secG_card2_icon6_title', {
                        s: (text: string) => <span className="s-text">{text}</span>,
                    }),
                    desc: t('secG_card2_icon6_desc'),
                },
            ],
        },
    ];
    return {
        caCardList,
    };
}
